
export default function CitationTemplateBox({ heading, source }) {

   let content = "Dane ZSK";
   if ( heading ) content += ", " + heading;
   content += `. Na podstawie danych: ${ source || ""}.`;
   content += " " + window.location.origin;

   return (
      <div className="box" style={{ display: "flex", flexDirection: "column", gap: "14px", flex: "1 1 550px" }}>
         <h3> Wzór cytowania </h3>

         <p>
            Umieszczając dane z tego badania w innych materiałach pamiętaj o zamieszczeniu informacji o źródle, wg poniższego wzoru:
         </p>
         
         <p>
            <strong dangerouslySetInnerHTML={{ __html: content }}/>

            <svg 
               width="24"
               height="25"
               viewBox="0 0 24 25"
               fill="none"
               className="stroke"
               xmlns="http://www.w3.org/2000/svg" 
               style={{ cursor: "pointer", position: "relative", top: 5, left: 8 }}
               onClick={ async( e ) => {
                  e.preventDefault();
                  e.stopPropagation();

                  await navigator.clipboard.writeText( content );
                  alert( "Skopiowano do schowka!" );
               }}   
            >
               <path d="M16 13.7164V17.9164C16 21.4164 14.6 22.8164 11.1 22.8164H6.9C3.4 22.8164 2 21.4164 2 17.9164V13.7164C2 10.2164 3.4 8.81641 6.9 8.81641H11.1C14.6 8.81641 16 10.2164 16 13.7164Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
               <path d="M22 7.71641V11.9164C22 15.4164 20.6 16.8164 17.1 16.8164H16V13.7164C16 10.2164 14.6 8.81641 11.1 8.81641H8V7.71641C8 4.21641 9.4 2.81641 12.9 2.81641H17.1C20.6 2.81641 22 4.21641 22 7.71641Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
         </p>
      </div>
   )
}